import * as i0 from "@angular/core";
export class StringPipesModule {
}
StringPipesModule.ɵfac = function StringPipesModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StringPipesModule)(); };
StringPipesModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: StringPipesModule });
StringPipesModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
